import api from "./api";
import { withActingInstitute } from "../utils/actingInstituteParam";

// Institute-wide leave endpoints (list / requests / statistics / leave-manage
// CRUD) resolve the institute server-side. For a Super Admin acting on a
// selected institute (dropdown-select flow), the acting institute id must be
// sent on the request; `withActingInstitute` appends it as an `instituteId`
// query param (no-op for admin/institute/teacher/hod, who resolve from their
// own profile/token). Self-scoped endpoints (own leaves / balance / apply) are
// also wrapped for consistency — the extra param is ignored there.
// See utils/actingInstituteParam.js.
const leaveService = {
  getLeaves: (params) => api.get("/leaves/all", withActingInstitute({ params })),

  getLeaveById: (id) => api.get(`/leaves/${id}`, withActingInstitute()),

  applyLeave: (leaveData, config = {}) =>
    api.post("/leaves/create", leaveData, withActingInstitute(config)),

  createLeave: (leaveData, config = {}) =>
    api.post("/leaves/create", leaveData, withActingInstitute(config)),

  getUserOwnLeaves: (params) =>
    api.get("/leaves/user-own-leaves", withActingInstitute({ params })),

  getLeaveDetails: (id) =>
    api.get("/leaves/leave-details", withActingInstitute({ params: { id } })),

  updateLeave(data, config = {}) {
    return api.put("/leaves/update", data, withActingInstitute(config));
  },

  cancelLeave: (id) =>
    api.put("/leaves/cancel-leave", {}, withActingInstitute({ params: { id } })),

  getLeaveRequests: (params) => api.get("/leaves/requests", withActingInstitute({ params })),

  approveLeave: (leaveId, data) =>
    api.post(`/leaves/${leaveId}/approve`, data, withActingInstitute()),

  rejectLeave: (leaveId, data) =>
    api.post(`/leaves/${leaveId}/reject`, data, withActingInstitute()),

  approveRejectLeave: (data) =>
    api.patch("/leaves/approve-reject", data, withActingInstitute()),

  getLeaveBalance: (userId) =>
    api.get(`/leaves/balance/${userId || "me"}`, withActingInstitute()),

  getLeaveTypes: () => api.get("/leaves/types", withActingInstitute()),

  getLeaveManagementTypes: () =>
    api.get("/leave-manage/leave-types", withActingInstitute()),

  getLeaveManagementTotalCount: () =>
    api.get("/leave-manage/total-leave-count", withActingInstitute()),

  getLeaveStatistics: (params) =>
    api.get("/leaves/statistics", withActingInstitute({ params })),

  getStudentLeaves: (studentId, params) =>
    api.get(`/leaves/student/${studentId}`, withActingInstitute({ params })),

  getClassLeaves: (classId, params) =>
    api.get(`/leaves/class/${classId}`, withActingInstitute({ params })),

  getLeaveManagementList: (params) =>
    api.get("/leave-manage/all", withActingInstitute({ params })),

  createLeaveManagementType: (payload, config = {}) =>
    api.post("/leave-manage/create", payload, withActingInstitute(config)),

  updateLeaveManagementType: (id, payload, config = {}) =>
    api.put("/leave-manage/update", payload, withActingInstitute({
      ...config,
      params: { ...(config.params || {}), id },
    })),

  deleteLeaveManagementType: (id, config = {}) =>
    api.delete("/leave-manage/delete", withActingInstitute({
      ...config,
      params: { ...(config.params || {}), id },
    })),

  updateLeaveManagementStatus: (id, status, config = {}) =>
    api.put(
      "/leave-manage/status-update",
      { status },
      withActingInstitute({
        ...config,
        params: { ...(config.params || {}), id },
      })
    ),

  getAllLeaves: (params) => {
    console.log('leaveService.getAllLeaves called with params:', params);
    return api.get("/leaves/all", withActingInstitute({ params }));
  },
  // Allocations
  getAllocations: () => api.get('/leave-manage/allocations', withActingInstitute()),
  createAllocation: (payload) =>
    api.post('/leave-manage/allocations/create', payload, withActingInstitute()),
  updateAllocation: (id, payload) =>
    api.put('/leave-manage/allocations/update', payload, withActingInstitute({ params: { id } })),
  deleteAllocation: (id) =>
    api.delete('/leave-manage/allocations/delete', withActingInstitute({ params: { id } })),
};

export default leaveService;
